import { MACROS_COLORS } from "~/modules/Trainee/TraineeProfile/TraineeFeatures/TraineeNutrition/TraineePdfGenerator/components/shared";

interface NutritionMacrosProps {
  calories: number;
  macros: { protein: number; carbs: number; fat: number };
  targets: { calories: number; macros: { protein: number; carbs: number; fat: number } };
}

const format = (value: number) => Intl.NumberFormat("pl-PL", { maximumFractionDigits: 1 }).format(value);

const ProgressBar = ({ value, target, color }: { value: number; target: number; color: string }) => (
  <div className="h-1.5 overflow-hidden rounded-full bg-gray-100">
    <div
      className="h-full rounded-full"
      style={{ width: `${target ? Math.min(100, (value * 100) / target) : 0}%`, backgroundColor: color }}
    />
  </div>
);

export const NutritionMacros = ({ calories, macros, targets }: NutritionMacrosProps) => {
  const macroRows = [
    { label: "Białko", value: macros.protein, target: targets.macros.protein, color: MACROS_COLORS.protein },
    { label: "Węglowodany", value: macros.carbs, target: targets.macros.carbs, color: MACROS_COLORS.carbs },
    { label: "Tłuszcze", value: macros.fat, target: targets.macros.fat, color: MACROS_COLORS.fat },
  ];

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2">
        <div className="flex items-baseline gap-1">
          <span className="text-2xl font-semibold tabular-nums text-gray-900">{format(calories)}</span>
          <span className="text-sm text-gray-500">/ {format(targets.calories)} kcal</span>
        </div>
        <ProgressBar value={calories} target={targets.calories} color={MACROS_COLORS.calories} />
      </div>
      <div className="grid grid-cols-3 gap-3">
        {macroRows.map((row) => (
          <div key={row.label} className="flex min-w-0 flex-col gap-1.5">
            <span className="truncate text-xs text-gray-500">{row.label}</span>
            <span className="text-[13px] font-medium tabular-nums text-gray-900">
              {format(row.value)}
              <span className="font-normal text-gray-400"> / {format(row.target)} g</span>
            </span>
            <ProgressBar value={row.value} target={row.target} color={row.color} />
          </div>
        ))}
      </div>
    </div>
  );
};
